/**
 * Queue GraphQL Fragments
 *
 * Reusable field selections for Queue queries and mutations.
 * Aligned with queue_model.rs GqlQueue exposed fields (non-skipped only).
 *
 * Fields marked #[graphql(skip)] in model are NOT included:
 * - tenantId, workflowInstanceId, taskIds, nextTaskId, eligibleActorIds
 * - slaId, metricIds, failedTransactionIds, retryPolicyId, checkpointIds
 * - overflowQueueId, createdBy, updatedBy
 */

import { gql } from '@apollo/client';

export const QUEUE_FIELDS_FRAGMENT = gql`
  fragment QueueFields on Queue {
    # Identity (2 fields - tenantId, workflowInstanceId are graphql(skip))
    id
    queueName

    # Formula Interaction (2 exposed - rest are graphql(skip))
    assignedActorMap
    eventTopic

    # Runtime State (8 fields)
    currentSize
    avgWaitTimeSeconds
    processingRatePerHour
    itemsProcessedToday
    oldestItemAgeSeconds
    slaBreachCount
    metricsCollectedCount
    lastAssignmentAt

    # Configuration (7 fields)
    queueType
    assignmentStrategy
    description
    eligibilityRules
    priorityRules
    deduplicationEnabled
    deduplicationWindowSeconds

    # Priority & Assignment (6 fields)
    defaultPriority
    priorityBoostEnabled
    priorityBoostThresholdSeconds
    priorityBoostIncrement
    maxConcurrentAssignments
    assignmentTimeoutSeconds

    # Capacity & Limits (3 fields - overflowQueueId is graphql(skip))
    capacity
    overflowStrategy
    warningThresholdPercent

    # Performance (4 fields)
    targetProcessingRatePerHour
    targetAvgWaitTimeSeconds
    performanceAlertEnabled
    lastPerformanceCheckAt

    # Lifecycle (2 fields - createdBy, updatedBy are graphql(skip), use resolvers)
    createdAt
    updatedAt

    # Complex Object Resolvers (3 fields)
    compressedId
    createdByActor {
      id
      displayName
      role
    }
    updatedByActor {
      id
      displayName
      role
    }
  }
`;
